import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as PhoneCallIcon } from './phoneCall.svg';

export const PhoneCall = IconHOC(PhoneCallIcon);
